import React from "react";
import type { DocumentRefineViewProps } from "@ps-bridge/contracts/documentRefine";
import * as styles from "@styles/Refine.css";

type RefineLoadingContractProps = Pick<DocumentRefineViewProps, never>;

const RefineLoadingView: React.FC<RefineLoadingContractProps> = () => (
  <div className={styles.loadingContainer}>
    <div className="animate-spin h-6 w-6 rounded-full border-2 border-base-200 border-t-accent-600" />
    <p>Loading ...</p>
  </div>
);

export default RefineLoadingView;
